import React, { useContext, useEffect, useState, useCallback, useRef, useMemo } from "react";

// ** Utils
import { AuthContext } from "@context/AuthContext"

export default function useWs({ roomId, action })
{
    const user = useContext(AuthContext)
    const [socket, setSocket] = useState(null)
    const [isSocketConnected, setIsSocketConnected] = useState(false)
    const [disconnectEvent, setDisconnectEvent] = useState(false)
    const [data, setData] = useState(
        Object
            .entries(action)
            .reduce(
                (obj, item) =>
                {
                    const actionName = item[0]
                    const initData = item[1].initData
                    obj[actionName] = initData
                    return obj
                },
                {}
        )
    )

    const props = useRef({roomId, action})
    const socketRef = useRef(null)

    useMemo(() =>
    {
        props.current = { roomId, action }
    }, [roomId, action])

    const socketSend = (data) =>
    {
        socket.send(
            JSON.stringify(data)
        );
    }
    useEffect(() =>
    {
        if(user?.userDetail?.id)
        {
            function socketConnect ()
            {
                let newWebSocket = new WebSocket(process.env.REACT_APP_WS_SERVER_URL + `/ws/users/${user?.userDetail?.id}/chat/`)

                /** Хэрэв socket connect хийгдсэн бол */
                newWebSocket.onopen = () =>
                {
                    setIsSocketConnected(true)
                    onOnlineUsers(newWebSocket)
                }

                /** Socket салсан бол дахин connect хийх function дуудна */
                newWebSocket.onclose = () =>
                {
                    // setDisconnectEvent(prev =>
                    //     {
                    //         if(!prev)
                    //         {
                    //             /** Socket салсан төлөвийг хадгалах */
                    //             setIsSocketConnected(prev =>
                    //                 {
                    //                     if(prev)
                    //                         return false
                    //                 })
                    //             setTimeout(socketConnect, 5000)
                    //         }
                    //     })
                }
                setSocket(newWebSocket)
                socketRef.current = newWebSocket
            }
            socketConnect()
        }
        else
        {
            disconnect()
        }
    }, [user?.userDetail?.id])

    const onOnlineUsers = useCallback((socket) =>
    {
        if(socket)
        {

            socket.onmessage = (event) =>
            {
                const data = JSON.parse(event.data)

                if(Object.keys(props.current.action).includes(data?.action) && (data.roomId === props.current.roomId || !data?.roomId|| props.current.roomId === undefined)) {
                    const format = props.current.action[data?.action]?.format
                    if (format) {
                        setData((prev) => {
                            const prevV = prev[data.action]
                            const fData = format(prevV, data)
                            prev[data.action] = fData
                            return {...prev}
                        })
                    }
                    else {
                        setData((prev) => {
                            prev[data?.action] = data
                            return {...prev}
                        })
                    }
                }
            }
        }
    }, [])


    /** Socket салгах */
    const disconnect = () =>
    {
        if (socketRef.current)
        {
            socketRef.current.close()
        }
    }

    useEffect(() =>
    {
        return () =>
        {
            disconnect()
            setDisconnectEvent(true)
        }
    }, [])

    return {
        data,
        setData,
        disconnect,
        socketSend,
        isSocketConnected
    }

}
